

import styled from "styled-components"
import { motion } from 'framer-motion';
import { setIsTrafficLayer, setLiveStreetView } from "../../../features/topPagesMap/topPagesMapSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import getPastDateAndTime from "../../../helper/date/getPastDateAndTime";
import InputCheckbox from "../../shared/input/new/InputCheckbox";

const Container = styled(motion.div)`
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 12px;

 
    
    .left-side-item{
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid ${({theme}) => theme.mainTextColor};

        &:first-child{
            margin-top: 20px;
        }

        &:last-child{
            margin-bottom: 20px;
        }

        h4{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
        }

        span{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
        }
    }    
`


const variants = {
    open: { height: 'auto', opacity: 1 },
    collapsed: { height: 0, opacity: 0 },
};

const TrackingMapLeftSideContentSection = ({ activeTabId, tabId}) => {

    const dispatch = useDispatch()

    const {
        liveStreetView,
        isTrafficLayer,

        trackingDatalocationList,
        trackingDataDriverInfo,
        trackingDataCurrentDriverLocation
    } = useSelector(state => state.topPagesMap)


    //! bu sürücünün ortalama hızını alan
    const getOrtSpeed = () => {
        
        const filteredList = trackingDatalocationList.filter(item => {
            return item.speed > 0
        })
        
        const total = filteredList.reduce((acc, current) => acc + current.speed * 3.6, 0);
        return total / filteredList.length;
    }

    //! bu sürücünün en yüksek hızını alan
    const getTopSpeed = () => {
        return Math.max(...trackingDatalocationList.map(item => item.speed  * 3.6)); 
    }

    //! bu sürücünün son konum alma tarihini gösteren
    const getLastKonumDate = () => {
        const date = getPastDateAndTime(trackingDataCurrentDriverLocation?.createdDate)?.formattedDate;
        const time = getPastDateAndTime(trackingDataCurrentDriverLocation?.createdDate)?.formattedTime;

        return {
            date,
            time,
        };
    }


  return (
    <Container
        initial="collapsed"
        animate={activeTabId === tabId ? 'open' : 'collapsed'}
        variants={variants}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
    >
        <div className="left-side-item">
            <h4>Sürücü</h4>
            <span>{trackingDataDriverInfo?.driverName}</span>
        </div>

        <div className="left-side-item">
            <h4>Telefon</h4>
            <span>{trackingDataDriverInfo?.driverPhoneNumber}</span>
        </div>

        <div className="left-side-item">
            <h4>Sefer Başlangıç Tarih Saat</h4>
            <span>{trackingDatalocationList[trackingDatalocationList?.length -1]?.createdDate && getPastDateAndTime(trackingDatalocationList[trackingDatalocationList?.length -1]?.createdDate)?.formattedDate}  {trackingDatalocationList[trackingDatalocationList?.length -1] && getPastDateAndTime(trackingDatalocationList[trackingDatalocationList?.length -1]?.createdDate)?.formattedTime}</span>
        </div>

        <div className="left-side-item">
            <h4>Ortalama Hız</h4>
            <span>{parseInt(getOrtSpeed())} km/sa</span>
        </div>

        <div className="left-side-item">
            <h4>En Yüksek Hız</h4>
            <span>{parseInt(getTopSpeed())} km/sa</span>
        </div>

        <div className="left-side-item">
            <h4>Son Konum</h4>
            <div style={{display: "flex", flexDirection: "column", gap:"3px"}}>
                <span>Lat: {parseFloat(trackingDataCurrentDriverLocation?.lat)}</span>
                <span>Lng: {parseFloat(trackingDataCurrentDriverLocation?.lng)}</span>
            </div>
        </div>

        <div className="left-side-item">
            <h4>Son Konum Alma Tarihi</h4>
            <span>{getLastKonumDate().date} {getLastKonumDate().time}</span>
        </div>

        <div className="left-side-item">
            <InputCheckbox data={liveStreetView} setData={() => dispatch(setLiveStreetView(!liveStreetView))} labelText={"Canlı konumu sokak görünümünde görüntüle"} fontWeight="600"/>
        </div>

        <div className="left-side-item">
            <InputCheckbox data={isTrafficLayer} setData={() => dispatch(setIsTrafficLayer(!isTrafficLayer))} labelText={"Canlı trafik yoğunluğunu görüntüle"} fontWeight="600"/>
        </div>
          
    </Container>
  )
}

export default TrackingMapLeftSideContentSection